export default [
    '51001',
    '51002',
    '51003',
    '51004',
    '51005',
    '51070',
    '51071',
    '51080',
    '52001',
    '52002',
    '52003',
    '52004',
    '52005',
    '52006',
    '52070',
    '52071',
    '52080',
    '35001',
    '35002',
    '35003',
    '35004',
    '35005',
    '35006',
    '35007',
    '35008',
    '35009',
    '35010',
    '35011',
    '35012',
    '35013',
    '35014',
    '35015',
    '35016',
    '35017',
    '35018',
    '35019',
    '35020',
    '35070',
    '35071',
    '35080',
    '35100',
    '35106',
    '35107',
    '35108',
    '35109',
    '35110',
    '35118',
    '35119',
    '35120',
    '35128',
    '35129',
    '35130',
    '35138',
    '35139',
    '35140',
    '35149',
    '35200',
    '35210',
    '35211',
    '35212',
    '35213',
    '35214',
    '35215',
    '35216',
    '35217',
    '35218',
    '35219',
    '35220',
    '35229',
    '35230',
    '35240',
    '35250',
    '35259',
    '35260',
    '35269',
    '35270',
    '35280',
    '35280',
    '35290',
    '35299',
    '35300',
    '35307',
    '35308',
    '35309',
    '35310',
    '35319',
    '35320',
    '35328',
    '35329',
    '35330',
    '35333',
    '35338',
    '35339',
    '35340',
    '35349',
    '35350',
    '35360',
    '35368',
    '35369',
    '35400',
    '35411',
    '35412',
    '35413',
    '35414',
    '35415',
    '35420',
    '35421',
    '35422',
    '35423',
    '35430',
    '35431',
    '35432',
    '35450',
    '35457',
    '35458',
    '35459',
    '35460',
    '35468',
    '35469',
    '35470',
    '35478',
    '35479',
    '35480',
    '35488',
    '35489',
    '35500',
    '35507',
    '35508',
    '35509',
    '35510',
    '35518',
    '35519',
    '35520',
    '35530',
    '35539',
    '35540',
    '35541',
    '35542',
    '35543',
    '35544',
    '35550',
    '35558',
    '35559',
    '35560',
    '35561',
    '35570',
    '35571',
    '35572',
    '35580',
    '35600',
    '35610',
    '35611',
    '35612',
    '35613',
    '35620',
    '35625',
    '35626',
    '35627',
    '35628',
    '35629',
    '35630',
    '35637',
    '35638',
    '35639',
    '35640',
    '35649',
    '35650',
    '35660',
    '38001',
    '38002',
    '38003',
    '38004',
    '38005',
    '38006',
    '38007',
    '38008',
    '38009',
    '38010',
    '38070',
    '38071',
    '38080',
    '38107',
    '38108',
    '38109',
    '38110',
    '38111',
    '38120',
    '38129',
    '38130',
    '38139',
    '38140',
    '38150',
    '38160',
    '38170',
    '38180',
    '38190',
    '38200',
    '38201',
    '38202',
    '38203',
    '38204',
    '38205',
    '38206',
    '38207',
    '38208',
    '38240',
    '38250',
    '38260',
    '38270',
    '38280',
    '38290',
    '38291',
    '38292',
    '38293',
    '38294',
    '38296',
    '38297',
    '38300',
    '38310',
    '38311',
    '38312',
    '38313',
    '38314',
    '38315',
    '38320',
    '38329',
    '38330',
    '38340',
    '38350',
    '38355',
    '38356',
    '38357',
    '38358',
    '38359',
    '38360',
    '38370',
    '38379',
    '38380',
    '38389',
    '38390',
    '38398',
    '38399',
    '38400',
    '38410',
    '38411',
    '38412',
    '38413',
    '38414',
    '38415',
    '38416',
    '38417',
    '38418',
    '38419',
    '38420',
    '38428',
    '38429',
    '38430',
    '38434',
    '38435',
    '38438',
    '38439',
    '38440',
    '38441',
    '38449',
    '38450',
    '38458',
    '38459',
    '38460',
    '38470',
    '38479',
    '38480',
    '38489',
    '38500',
    '38508',
    '38509',
    '38510',
    '38520',
    '38530',
    '38540',
    '38550',
    '38560',
    '38570',
    '38579',
    '38580',
    '38588',
    '38589',
    '38590',
    '38591',
    '38592',
    '38593',
    '38594',
    '38595',
    '38600',
    '38610',
    '38611',
    '38612',
    '38613',
    '38614',
    '38615',
    '38616',
    '38617',
    '38618',
    '38619',
    '38620',
    '38626',
    '38627',
    '38628',
    '38629',
    '38630',
    '38631',
    '38632',
    '38639',
    '38640',
    '38649',
    '38650',
    '38652',
    '38660',
    '38670',
    '38677',
    '38678',
    '38679',
    '38680',
    '38683',
    '38684',
    '38685',
    '38686',
    '38687',
    '38688',
    '38689',
    '38690',
    '38700',
    '38710',
    '38711',
    '38712',
    '38713',
    '38714',
    '38715',
    '38720',
    '38726',
    '38727',
    '38728',
    '38729',
    '38730',
    '38738',
    '38739',
    '38740',
    '38749',
    '38750',
    '38758',
    '38759',
    '38760',
    '38767',
    '38768',
    '38769',
    '38770',
    '38779',
    '38780',
    '38787',
    '38788',
    '38789',
    '38800',
    '38801',
    '38810',
    '38811',
    '38812',
    '38813',
    '38820',
    '38829',
    '38830',
    '38840',
    '38849',
    '38850',
    '38852',
    '38860',
    '38869',
    '38870',
    '38879',
    '38890',
    '38891',
    '38892',
    '38900',
    '38910',
    '38911',
    '38912',
    '38913',
    '38914',
    '38915',
    '38916',
    '38917'
]